import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "A DeGen",
          "A Crypto Educator",
          "A Moderator",
          "A Marketer",

          "A Caller",
          "An Influencer",
          "A Dev",
          "A Smart Contract Developer",
          "A Team and Community Advisor",
          "A Community Manager",
          "A QOL",
          "A Feature Trader",
          "A Spot Trader",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
